import { type VariantProps, cva } from "class-variance-authority";

export const modalContent = cva(
  [
    "relative flex flex-col items-center gap-modal-gap-content p-6 pt-4",
    "w-full max-w-[480px]",
    "border-elevation-outline-default-1 bg-elevation-fill-default-1 outline-none",
    "pointer-events-auto",
  ],
  {
    variants: {
      aside: {
        left: "h-screen rounded-none border-r",
        right: "h-screen rounded-none border-l",
        center: "rounded-xl border",
      },
    },
    defaultVariants: {
      aside: "center",
    },
  },
);

export interface ModalVariantProps extends VariantProps<typeof modalContent> {}

export const modalOverlay = cva(
  ["fixed inset-0 z-50 flex h-(--visual-viewport-height) w-screen overflow-y-auto bg-support-overlay"],
  {
    variants: {
      aside: {
        left: "p-0",
        right: "p-0",
        center: "p-4",
      },
    },
    defaultVariants: {
      aside: "center",
    },
  },
);

export const modalMain = cva(["pointer-events-none my-auto flex w-full"], {
  variants: {
    aside: {
      left: "entering:animate-drawer-enter-left exiting:animate-drawer-exit-left justify-start",
      right: "entering:animate-drawer-enter-right exiting:animate-drawer-exit-right justify-end",
      center: "justify-center",
    },
  },
  defaultVariants: {
    aside: "center",
  },
});
